import { scrubSensitiveKeys } from './scrubSensitiveKeys';
import type { EventFilter, TelemetryEvent } from './types';

/** Scrubs auth keys/tokens in `event.context` in place; never drops. */
export function scrubEventContext<T extends TelemetryEvent>(): EventFilter<T> {
  return (event) => {
    if (event.context) scrubSensitiveKeys(event.context);
    return true;
  };
}
